import { MuiAspectRatio } from '@lsoft/mui';
import React from 'react';

export const ContactMap = () => {
	return (
		<MuiAspectRatio aspectRatio={16 / 9}>
			<iframe
				src={
					'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2583.219475301233!2d6.2448307162366845!3d49.65016377937297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479545ec149b8d5b%3A0x925a51355d82c92b!2sLToys%20-%20Bricks%2C%20Figures%20%26%20More!5e0!3m2!1sen!2sde!4v1613059374932!5m2!1sen!2sde'
				}
				width={'100%'}
				height={'100%'}
				frameBorder={0}
			/>
		</MuiAspectRatio>
	);
};
